import { Checkbox, FormControl, Link, SimpleGrid } from '@chakra-ui/react'
import { Profile, UnitSystem } from '../../../../../types/FirestoreUser'
import BasicInfoSection from './BasicInfoSection'
import DemographicsSection from './DemographicsSection'
import MedicalDatesSection from './MedicalDatesSection'
import AddressSection from './AddressSection'
import EmergencyContactSection from './EmergencyContactSection'

interface PersonalFormProps {
  profile: Profile
  units: UnitSystem
  extraInfoRequired: boolean
  areDateFieldsDisabled: boolean
  areFirstSymptomsFieldsDisabled: boolean
  onUpdate: (changes: Partial<Profile>) => void
  onUpdateUnitSystem: (unitSystem: UnitSystem) => void
  isMine: boolean
  isSaved: boolean
  isBirthDateLocked?: boolean
  isDiagnosisDateLocked?: boolean
  isFirstSymptomsDateLocked?: boolean
}

const PersonalForm = ({
  profile,
  units,
  extraInfoRequired,
  areDateFieldsDisabled,
  areFirstSymptomsFieldsDisabled,
  onUpdate,
  onUpdateUnitSystem,
  isMine,
  isSaved,
  isBirthDateLocked,
  isDiagnosisDateLocked,
  isFirstSymptomsDateLocked,
}: PersonalFormProps) => {
  return (
    <SimpleGrid
      spacing={3}
      columns={{
        sm: 1,
        md: 2,
      }}
    >
      <BasicInfoSection
        profile={profile}
        units={units}
        extraInfoRequired={extraInfoRequired}
        isMine={isMine}
        isSaved={isSaved}
        onUpdate={onUpdate}
        onUpdateUnitSystem={onUpdateUnitSystem}
      />

      <DemographicsSection profile={profile} onUpdate={onUpdate} isBirthDateLocked={isBirthDateLocked} />

      <MedicalDatesSection
        profile={profile}
        extraInfoRequired={extraInfoRequired}
        areDateFieldsDisabled={areDateFieldsDisabled}
        areFirstSymptomsFieldsDisabled={areFirstSymptomsFieldsDisabled}
        isDiagnosisDateLocked={isDiagnosisDateLocked}
        isFirstSymptomsDateLocked={isFirstSymptomsDateLocked}
        onUpdate={onUpdate}
      />

      <AddressSection profile={profile} onUpdate={onUpdate} />

      <EmergencyContactSection
        profile={profile}
        extraInfoRequired={extraInfoRequired}
        onUpdate={onUpdate}
      />

      {isMine && (
        <>
          <div></div>
          <FormControl>
            <Checkbox
              isChecked={profile.agreedToProfileCheckbox}
              onChange={(e) =>
                onUpdate({
                  agreedToProfileCheckbox: e.target.checked,
                })
              }
            >
              I Agree to the{' '}
              <Link href='/terms' isExternal color='purple.600'>
                Terms and Conditions
              </Link>
            </Checkbox>
          </FormControl>
        </>
      )}
    </SimpleGrid>
  )
}

export default PersonalForm
